import React from 'react';
import { WrapperLegend, LegendItem } from './style';

export default function Legends({ itens }) {
  return (
    <WrapperLegend>
      {itens &&
        itens.map((item, index) => {
          return (
            <LegendItem key={index + 1} colorInfo={item.color}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path d="M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z" />
              </svg>
              <p>{item.text}</p>
            </LegendItem>
          );
        })}
    </WrapperLegend>
  );
}
